export const CREATE_ACCOUNT_FORM_ID = "createAccountForm";
export const YOUR_INFORMATION_FORM_ID = "yourInformationForm";
export const SETUP_PROFILE_FORM_ID = "setupProfileForm";
export const CONTACT_INFORMATION_FORM = "contactInformationForm";
export const MEMBER_PAGES_FORM = "memberPagesForm";

export const NAV_TYPE_NEXT = "next";
export const NAV_TYPE_PREV = "prev";
